import type { L10n } from '../types'
import type { BeeArchetypeId } from '../types/engagement'

/**
 * "Seu tipo de abelha" — CONFIGURABLE CONTENT CATALOGUE (product copy, editable in Admin).
 * Playful, period-only engagement profile. Not a health or personality diagnosis,
 * not permanent, not a ranking. Selection logic lives in utils/recap.ts.
 */
export const beeArchetypes: Record<BeeArchetypeId, { name: L10n; description: L10n }> = {
  movement: {
    name: { 'pt-BR': 'Abelha do Movimento', 'en-US': 'Movement Bee' },
    description: {
      'pt-BR': 'Você manteve o corpo em movimento com constância. Cada treino somou.',
      'en-US': 'You kept your body moving, steadily. Every session added up.',
    },
  },
  hydration: {
    name: { 'pt-BR': 'Abelha da Hidratação', 'en-US': 'Hydration Bee' },
    description: {
      'pt-BR': 'A água foi sua aliada mais fiel. Um cuidado simples, feito com constância.',
      'en-US': 'Water was your most faithful ally. A simple habit, kept with care.',
    },
  },
  mind: {
    name: { 'pt-BR': 'Abelha Serena', 'en-US': 'Serene Bee' },
    description: {
      'pt-BR': 'Você reservou momentos seus com frequência. Calma também se constrói.',
      'en-US': 'You made time for yourself often. Calm is something you build.',
    },
  },
  nutrition: {
    name: { 'pt-BR': 'Abelha da Nutrição', 'en-US': 'Nutrition Bee' },
    description: {
      'pt-BR': 'Suas escolhas à mesa foram consistentes. Cuidado que vem de dentro.',
      'en-US': 'Your choices at the table were consistent. Care that starts inside.',
    },
  },
  sleep: {
    name: { 'pt-BR': 'Abelha do Descanso', 'en-US': 'Rest Bee' },
    description: {
      'pt-BR': 'Você priorizou boas noites com regularidade. Descansar também é evoluir.',
      'en-US': 'You prioritised good nights regularly. Rest is progress too.',
    },
  },
  balanced: {
    name: { 'pt-BR': 'Abelha do Equilíbrio', 'en-US': 'Balance Bee' },
    description: {
      'pt-BR': 'Seus hábitos caminharam juntos, sem um único destaque. Equilíbrio é uma conquista.',
      'en-US': 'Your habits moved together, with no single standout. Balance is an achievement.',
    },
  },
}
